export default "__VITE_ASSET__DO285KQ9__"